import React from 'react';
import './tasksHeader.css';
import { useDispatch, useSelector } from "react-redux";
import { taskArchiveAction, taskFormAction } from "../../../redux/rootReducer";
import { TASK_FORM_INITIAL } from "../../../redux/initialStateConstant";
import Toggle from "../../Toggle/Toggle";

const TasksHeader = () => {
    const dispatch = useDispatch();

    const tack_archive = useSelector(state => state.task_archive);

    return (
        <>
            <Toggle active={ tack_archive } setHandler={ value => dispatch(taskArchiveAction(value)) } captionLeft={ 'Архив' } captionRight={ 'Текущие' }/>
            <div className="button button--add"
                onClick={ () => dispatch(taskFormAction({ ...TASK_FORM_INITIAL, open: true })) }
            >Добавить задачу</div>
        </>
    );
};

export default TasksHeader;